import { render, staticRenderFns } from "./joinCBH.vue?vue&type=template&id=161af39c&scoped=true&"
import script from "./joinCBH.vue?vue&type=script&lang=js&"
export * from "./joinCBH.vue?vue&type=script&lang=js&"
import style0 from "./joinCBH.vue?vue&type=style&index=0&id=161af39c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161af39c",
  null
  
)

export default component.exports